module.exports = __webpack_public_path__ + "img/c08_buildingtechcarryingbaskets_Normal_ua.98313986.webp";